package com.eladfinish.bible.contest.screens.chapterComplete.features.progressiveExposure

import kotlinx.collections.immutable.ImmutableList

/**
 * Holds the incremental "progressive exposure" progress for a chapter.
 *
 * elementsNumber is typically 2 * numberOfVerses, because each verse is split into:
 * - Step 0: (Ot Pasuk + Reysha) and/or partial completion
 * - Step 1: (Seyfa + Colon) and/or partial completion
 *
 * currentSegment moves over these steps.
 * currentWord is used only in WORD mode to remember where we are within the current step.
 */
data class ProgressiveExposureState(
    val partitionedChapter: List<List<List<String>>>,
    val verseStartSegments: ImmutableList<Int>, // size = versesCount + 1, last = elementsNumber
    val currentSegment: Int,
    val currentWord: Int,
    val elementsNumber: Int,
    val renderedTextSoFar: String,
) {
    fun isFinished(): Boolean = currentSegment >= elementsNumber
}
